export default __webpack_public_path__ + "static/media/Iron.82dac49e.png";